import Restaurant from './Restaurant';
import { useState, useEffect } from 'react';
import { MdSearch, MdAddBusiness } from 'react-icons/md';
import { dishStyles, cookingTypes } from '../Constant/constants';

const Restaurants = (props) =>{

    const [searched, setSearch] = useState("");
    const [savedRestaurants, setSavedRes] = useState([]);

    const autoId = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let autoId = '';
        for (let i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return autoId;
    }
    
    //Filter results by search input
    useEffect(() => {
        if(searched.trim().length === 0){
            //restore results
            if(savedRestaurants.length !== 0){
                props.setResList(savedRestaurants);
                setSavedRes([]);
            }
        }else{
            // Save results before filtering
            if(savedRestaurants.length === 0){
                setSavedRes(props.restaurantList);
            }

            let temp;
            if(savedRestaurants.length === 0){
                temp = props.restaurantList.slice();
            }else{
                temp = savedRestaurants.slice();
            }

            let filtered = [];

            temp.forEach((restaurant) => {
                let add = false;



                let typeSel = '';
                let styleSel = '';
                for(let d of dishStyles){
                    if(d.label.toLowerCase().includes(searched.toLowerCase())){
                        typeSel = d.value;
                        break;
                    }
                }

                for(let s of cookingTypes){
                    if(s.name.toLowerCase().includes(searched.toLowerCase())){
                        styleSel = s.code;
                        break;
                    }
                }

                if(restaurant.dishStyle && typeSel !== ''){
                    for(let ds of restaurant.dishStyle){
                        if(ds === typeSel){
                            add = true;
                            break;
                        }
                    }
                }

                if(restaurant.cookingStyle && restaurant.cookingStyle === styleSel){
                    add = true;
                }
                
                if(restaurant.name.toLowerCase().includes(searched.toLowerCase())){
                    add = true;
                }
                
                if(add){
                    filtered.push(restaurant);
                }
            });
            
            props.setResList(filtered);
        }
    }, [searched, props, savedRestaurants]);

    return (
        <div className='fitHeight'>
            <div className='title tx-white'>Restaurantes</div>
            <div className='ContentContainer mt-2 bg-rounded bg-container'>
                <div className='Toolbar tx-white'>
                    <MdSearch size='1rem' style={{float: 'left'}} pointerEvents='none' />
                    <input onChange={(e) => setSearch(e.target.value)} className='ml-1 searchInput' type='text' placeholder='Buscar un restaurante...' />

                    <div className='d-inline-block d-flex flex-center ml-2'>
                        <button onClick={() => {props.router(`New/${autoId()}`)}} className='cbtn-md-add d-inline-block mx-1'>
                            <MdAddBusiness size='1rem' pointerEvents='none' />
                        </button><span className='btn-label'>Agregar Restaurante</span>
                    </div>
                </div>
                
                <div className='RestaurantContainer mt-2'>
                    {
                        
                        props.restaurantList.map((res) => {
                            return <Restaurant key={res.id} id={res.id} data={res} callback={props.callback} storage={props.storage} router={props.router} />;
                        })
                    }                    
                </div>
            </div>
        </div>
    );

}

export default Restaurants;